import {Component, Input, OnDestroy, OnInit, OnChanges, SimpleChanges, ViewChild, Output, EventEmitter} from '@angular/core';
import {FormControl} from '@angular/forms';
import { MatSelect, MatSnackBar } from '@angular/material';
import { Subscription } from 'rxjs';
import { Patient } from 'src/app/patient-management/models/patient.interface';
import { PatientService } from 'src/app/patient-management/services/patient.service';

@Component({
  selector: 'app-multiselect-recent-medications',
  templateUrl: './multiselect-recent-medications.component.html',
  styleUrls: ['./multiselect-recent-medications.component.scss']
})
export class MultiselectRecentMedicationsComponent implements OnInit, OnChanges, OnDestroy {

  recentMedicationsList: string[] = [];
  selectedRecentMedications: string[] = [];
  formSearch: FormControl = new FormControl('');

  recentMedicationControl: FormControl = new FormControl([]);
  @Input() patient: Patient;
  @Output() restoreFocus = new EventEmitter<void>();
  @ViewChild(MatSelect, { static: false }) selectElement: MatSelect;

  subscription: Subscription = new Subscription();

  constructor(
    public patientService: PatientService,
    public snackBar: MatSnackBar
  ) {
  }

  ngOnInit() {
    this.subscription.add(this.recentMedicationControl.valueChanges.subscribe(this.updateSelectedRecentMedications.bind(this)));
    if (this.patient && this.patient.id) {
      this.getRecentMedications();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    // If the patient input changes and has a valid id, refresh the medications list
    if (changes.patient && changes.patient.currentValue && 
        changes.patient.currentValue.id && 
        (!changes.patient.previousValue || 
         changes.patient.previousValue.id !== changes.patient.currentValue.id)) {
      this.getRecentMedications();
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  getRecentMedications() {
    if (!this.patient || !this.patient.id) {
      console.warn('Cannot get medications: Patient is undefined or missing ID');
      return;
    }
    
    this.subscription.add(
      this.patientService.getPatientRecentMedications(this.patient.id).subscribe(
        (result) => {
          if (result.length === 0) {
            this.recentMedicationsList = ['None'];
            return;
          }
          this.recentMedicationsList = result;
        },
        (error) => {
          console.error('Error fetching recent medications:', error);
          this.recentMedicationsList = ['Error loading medications'];
        }
      )
    );
  }
  
  updateSelectedRecentMedications() {
    const selected = this.recentMedicationsList.filter((medication) => this.recentMedicationControl.value.includes(medication));
    this.selectedRecentMedications = selected;
  }

  copyToClipboard() {
    const clipBoardString = this.selectedRecentMedications.join('\n\n');

    navigator.clipboard.writeText(clipBoardString).then(() => {
      this.snackBar.open('Copied To Clipboard', 'Dismiss', { duration: 2000 });

      this.recentMedicationControl.setValue([]);
      this.selectedRecentMedications = [];

      this.selectElement.close();
      
      this.restoreFocus.emit();
    });
  }
}
